import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage, validateOverviewSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. `?window=` picks the posture window.
 */
function OverviewRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <OverviewPage clusterId={clusterId} scopeId={scopeId} search={search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/overview')({
  validateSearch: validateOverviewSearch,
  component: OverviewRoute,
})
